// src/components/tools/room-ideas/validators.js

// -----------------------------
// Helpers
// -----------------------------

export const isNonEmptyString = (value) =>
  typeof value === "string" && value.trim().length > 0;

export const isValidHexColor = (value) =>
  typeof value === "string" &&
  /^#([0-9A-Fa-f]{6})$/.test(value);

// -----------------------------
// Field-Level Validators
// -----------------------------

export const validateRoomType = (roomType) => {
  if (!isNonEmptyString(roomType)) {
    return "Please select a room to explore.";
  }
  return null;
};

export const validateStyle = (style) => {
  if (!isNonEmptyString(style)) {
    return "Please select a style.";
  }
  return null;
};

export const validateBudget = (budget) => {
  if (!isNonEmptyString(budget)) {
    return "Please select a budget range.";
  }
  return null;
};

export const validatePrimaryColor = (color) => {
  if (!isValidHexColor(color)) {
    return "Please choose a valid primary color.";
  }
  return null;
};

export const validateSecondaryColor = (color) => {
  if (!isValidHexColor(color)) {
    return "Please choose a valid secondary color.";
  }
  return null;
};

// Optional image — only validate if present
export const validateReferenceImage = (referenceImage) => {
  if (!referenceImage) return null;

  if (
    typeof referenceImage !== "string" ||
    !referenceImage.startsWith("data:image")
  ) {
    return "Invalid image upload.";
  }

  return null;
};


// -----------------------------
// Full Form Validation
// -----------------------------

export const validateRoomIdeaForm = (formValues) => {
  const errors = {};

  const roomError = validateRoomType(formValues.roomType);
  if (roomError) errors.roomType = roomError;

  const styleError = validateStyle(formValues.style);
  if (styleError) errors.style = styleError;

  const budgetError = validateBudget(formValues.budget);
  if (budgetError) errors.budget = budgetError;

  const primaryColorError = validatePrimaryColor(formValues.primaryColor);
  if (primaryColorError) errors.primaryColor = primaryColorError;

  const secondaryColorError = validateSecondaryColor(formValues.secondaryColor);
  if (secondaryColorError) errors.secondaryColor = secondaryColorError;

  const imageError = validateReferenceImage(formValues.referenceImage);
  if (imageError) errors.referenceImage = imageError;


  return errors;
};

// -----------------------------
// Submit Gate
// -----------------------------

export const canSubmitRoomIdeaForm = (formValues) => {
  const errors = validateRoomIdeaForm(formValues);
  return Object.keys(errors).length === 0;
};
